const HomeIcon = ({
    size,
    width = 42,
    height = 42,
    color = "#0468fb",
    ...rest
  }) => {

    const w = width  ?? size;
    const h = height ?? size;

    return (
    <svg viewBox="0 0 1080 1080" width={w} height={h} version="1.1" xmlns="http://www.w3.org/2000/svg" >
       
       <g transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
       fill={color} stroke="none">
       <path d="M5310 9132 c-79 -21 -142 -66 -323 -229 -73 -65 -370 -328 -662 -583
       -291 -256 -561 -494 -600 -530 -38 -36 -147 -132 -242 -213 -94 -81 -184 -160
       -200 -175 -15 -15 -140 -127 -278 -247 -634 -557 -978 -860 -1025 -904 -14
       -13 -69 -61 -122 -107 -107 -92 -119 -107 -173 -209 l-37 -70 4 -110 c4 -107
       5 -112 45 -185 83 -149 195 -221 378 -241 129 -14 173 -26 233 -65 113 -75
       172 -159 201 -283 21 -87 21 -109 21 -1412 0 -1320 0 -1323 21 -1402 18 -64
       31 -91 71 -139 65 -77 112 -111 198 -139 53 -17 67 -25 59 -35 -8 -10 0 -14
       33 -19 24 -3 385 -3 803 0 971 7 2495 7 3430 0 402 -3 745 -3 763 0 26 5 31 9
       23 19 -9 10 6 18 65 37 84 27 149 74 210 154 74 98 68 -15 74 1525 l6 1385 27
       70 c15 39 27 71 27 71 0 1 20 28 45 59 49 63 149 137 211 154 21 7 95 14 164
       18 111 5 135 10 210 40 111 44 176 106 231 218 37 77 39 84 39 180 0 98 0 102
       -42 183 -42 81 -81 125 -203 231 -22 19 -166 145 -320 281 -154 135 -428 376
       -610 535 -181 159 -456 400 -610 535 -417 366 -1058 928 -1420 1245 -176 154
       -342 295 -368 313 -83 59 -232 77 -357 44z m927 -4774 c73 -36 118 -82 144
       -145 l24 -58 3 -1031 2 -1031 -31 -7 c-41 -8 -1827 -8 -1868 0 l-31 7 2 1031
       3 1031 23 57 c25 62 75 112 146 148 40 20 57 20 790 20 l749 0 44 -22z"/>
       </g>
       </svg>
       
    
    );
};



export default HomeIcon;